export const ActionTypes = {
    CHANGE_CATEGORY: 'CHANGE_CATEGORY',
    CHANGE_DIFFICULTY: 'CHANGE_DIFFICULTY',
    CHANGE_AMOUNT: 'CHANGE_AMOUNT',
    CHANGE_NAME: 'CHANGE_NAME',
    CHANGE_SCORE: 'CHANGE_SCORE'
}